(() => {
  const body = document.body;
  let isLoaded = false;
  let fetchPromise = null;

  function getMount() {
    return document.querySelector('[data-mobile-filter-mount]');
  }

  function getDrawer() {
    return document.getElementById('MobileFilterDrawer');
  }

  function getTrigger() {
    return document.querySelector('[data-mobile-filter-open]');
  }

  function sectionUrl() {
    const url = new URL(window.location.href);
    url.searchParams.set('section_id', 'mobile-facets-drawer');
    return url.toString();
  }

  function openDrawer() {
    const drawer = getDrawer();
    const trigger = getTrigger();

    if (!drawer) return;

    drawer.showModal();
    body.classList.add('mobile-filter-open');

    if (trigger) {
      trigger.setAttribute('aria-expanded', 'true');
    }
  }

  function closeDrawer() {
    const drawer = getDrawer();
    
    if (drawer) {
      drawer.close();
    }
  }

  function loadDrawer() {
    const mount = getMount();

    if (!mount || isLoaded) return Promise.resolve();
    if (fetchPromise) return fetchPromise;

    fetchPromise = (async () => {
      try {
        const response = await fetch(sectionUrl(), {
          method: 'GET',
          credentials: 'same-origin',
          headers: {
            'X-Requested-With': 'XMLHttpRequest'
          }
        });

        if (!response.ok) {
          throw new Error(`Mobile facets request failed: ${response.status}`);
        }

        const html = await response.text();
        const temp = document.createElement('div');
        temp.innerHTML = html.trim();

        const innerForm = temp.querySelector('facet-filters-form');

        if (!innerForm) {
          throw new Error('facet-filters-form was not found in fetched section HTML.');
        }

        mount.innerHTML = '';
        mount.appendChild(innerForm);
        isLoaded = true;
      } catch (error) {
        console.error(error);
        fetchPromise = null; // Allow retry on failure
      }
    })();
    
    return fetchPromise;
  }

  document.addEventListener('DOMContentLoaded', () => {
    const drawer = getDrawer();
    if (drawer) {
      drawer.addEventListener('close', () => {
        const trigger = getTrigger();
        body.classList.remove('mobile-filter-open');
        if (trigger) {
          trigger.setAttribute('aria-expanded', 'false');
          trigger.focus({ preventScroll: true });
        }
      });
    }
  });

  window.addEventListener('load', () => {
    const requestIdle = window.requestIdleCallback || ((cb) => setTimeout(cb, 2000));
    requestIdle(() => loadDrawer());
  });

  ['pointerenter', 'touchstart'].forEach(eventType => {
    document.addEventListener(eventType, (event) => {
      if (event.target.closest('[data-mobile-filter-open]')) {
        loadDrawer();
      }
    }, { capture: true, passive: true });
  });

  document.addEventListener('click', (event) => {
    const openButton = event.target.closest('[data-mobile-filter-open]');

    if (openButton) {
      event.preventDefault();
      openDrawer();
      loadDrawer(); // Ensure it loads if not already loading
      return;
    }

    const closeButton = event.target.closest('[data-mobile-filter-close]');

    if (closeButton) {
      event.preventDefault();
      closeDrawer();
    }
  });
})();